/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './BancoDoAuto25BannerMoveBrasil.css';
import RedButton from '@/components/atoms/RedButton';

function BancoDoAuto25BannerMoveBrasil() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="banco-auto-25-banner">
        <ContainerHome24>
          <div className="hero-img">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 413 && (
                  <img
                    src="assets/banco-do-auto25/hero-move-brasil/img-280.png"
                    alt="Motorista de aplicativo dentro de carro novo conquistado por meio de financiamento de veículos com a Santander Financiamentos pelo Programa Move Brasil."
                    className=""
                  />
                )}
                {width > 413 && width <= 599 && (
                  <img
                    src="assets/banco-do-auto25/hero-move-brasil/img-346.png"
                    alt="Motorista de aplicativo dentro de carro novo conquistado por meio de financiamento de veículos com a Santander Financiamentos pelo Programa Move Brasil."
                    className=""
                  />
                )}
                {width > 599 && width <= 799 && (
                  <img
                    src="assets/banco-do-auto25/hero-move-brasil/img-379.png"
                    alt="Motorista de aplicativo dentro de carro novo conquistado por meio de financiamento de veículos com a Santander Financiamentos pelo Programa Move Brasil."
                    className=""
                  />
                )}
                {width > 799 && (
                  <img
                    src="assets/banco-do-auto25/hero-move-brasil/img-572.png"
                    alt="Motorista de aplicativo dentro de carro novo conquistado por meio de financiamento de veículos com a Santander Financiamentos pelo Programa Move Brasil."
                    className=""
                  />
                )}
              </>
            )}
          </div>
          <div className="hero-contain">
            {/* <div className="hero-selo">
              <img src="assets/mes-do-ambiente/home/img-selo.svg" alt="" className="" />
            </div> */}
            <div className="hero-texts">
              <h1 className="hero-title">Financiamento de carro pelo Programa Move Brasil</h1>
              <h3 className="hero-sub-title">
                Aproveite condições facilitadas e acessíveis para conquistar seu veículo novo.
              </h3>
            </div>
            <div className="hero-buttons">
              <WhiteButton
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=banco-do-auto:banner&int_campaign=simular-financiamento"
                id="hero-button-simular-financiamento"
                wide
                target="_blank"
              >
                Quero Simular
              </WhiteButton>
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default BancoDoAuto25BannerMoveBrasil;
